import { Button, Card, DatePicker, Form, Icon, Input, Select, Spin, Table } from 'antd';
import React from "react";
import { isArray, sanitizeFieldName } from "../../util/methods";
import moment from "moment";
import DocumentList from "../../components/DocumentList";

let parentPresent = [], parentAssetCode = [];

class View extends React.Component {
  constructor() {
    super();
    this.addAsset = this.addAsset.bind(this);
    this.id = 0;
    this.state = {
      keys: [],
      intervalKeys: {},
      parentIntervalKeys: {},
      saleOrderData: {
        assets: [],
      },
      assetsAddedInLocation: {},
      assetsPresent: [],
      documentData: [],
      parentPresent: [],
      parentAssetCode: [],
    };
  }


  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const { data: { assets = [{}] } } = this.props;
    this.setState({
      keys: assets,
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data.assets && JSON.stringify(nextProps.data.assets) !== JSON.stringify(this.props.data.assets)) {
      const newArr = [];
      nextProps.data.assets.map((item, idx) => {
        const { intervalKeys } = this.state;
        const { parentIntervalKeys } = this.state;

        item.service && item.service.length && item.service.map((itm, index) => {
          if (intervalKeys[`${idx}`]) {
            intervalKeys[`${idx}`].keys.push(`interval${++intervalKeys[`${idx}`].id}`);
          } else {
            intervalKeys[`${idx}`] = {
              id: 0,
              keys: ['interval0'],
            }
          }
        });

        item.parentService && item.parentService.length && item.parentService.map((itm, index) => {
          if (parentIntervalKeys[`${idx}`]) {
            parentIntervalKeys[`${idx}`].keys.push(`parentInterval${++parentIntervalKeys[`${idx}`].id}`);
          } else {
            parentIntervalKeys[`${idx}`] = {
              id: 0,
              keys: ['parentInterval0'],
            }
          }
        });

        this.setState({ intervalKeys, parentIntervalKeys });
        item.asset && newArr.push(item.asset._id);
      });

      this.setState({
        keys: nextProps.data.assets,
        assetsPresent: newArr,
      });
    }
  }

  removeAsset = (index, boxIndex) => {
    const { keys, assetsPresent } = this.state;
    const { form, filters } = this.props;
    const item = filters['assets'];
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue('assets');
    val.splice(boxIndex, 1);
    keys.splice(boxIndex, 1);
    assetsPresent.splice(boxIndex, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`assets[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }
    this.setState({
      keys: keys,
      assetsPresent: assetsPresent,
    });
  };

  addAsset = () => {
    const { keys } = this.state;
    keys.push(`${'assets'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  removeInterval = (index, idx) => {
    const { intervalKeys } = this.state;
    const { form, filters } = this.props;
    const item = filters['assets']['schema']['service'];
    const val = form.getFieldValue('assets')[`${index}`]['service'];
    val.splice(idx, 1);
    intervalKeys[`${index}`].keys.splice(idx, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm, kk) => {
        form.setFieldsValue({
          [`assets[${index}]['service'][${i}]['${itm}']`]: val[i][`${itm}`],
        });
      });
    }

    this.setState({ intervalKeys });
  };

  removeParentInterval = (index, idxx) => {
    const { parentIntervalKeys } = this.state;
    const { form, filters } = this.props;
    const item = filters['assets']['schema']['service'];
    const val = form.getFieldValue('assets')[`${index}`]['parentService'];
    val.splice(idxx, 1);
    parentIntervalKeys[`${index}`].keys.splice(idxx, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm, kk) => {
        form.setFieldsValue({
          [`assets[${index}]['parentService'][${i}]['${itm}']`]: val[i][`${itm}`],
        });
      });
    }

    this.setState({ parentIntervalKeys });
  };

  addParentInterval = (idxx) => {
    const { parentIntervalKeys } = this.state;
    if (parentIntervalKeys[`${idxx}`]) {
      parentIntervalKeys[`${idxx}`].keys.push(`parentInterval${++parentIntervalKeys[`${idxx}`].id}`);
    } else {
      parentIntervalKeys[`${idxx}`] = {
        id: 0,
        keys: ['parentInterval0'],
      }
    }
    this.setState({ parentIntervalKeys });
  };

  addInterval = (idx) => {
    const { intervalKeys } = this.state;
    if (intervalKeys[`${idx}`]) {
      intervalKeys[`${idx}`].keys.push(`interval${++intervalKeys[`${idx}`].id}`);
    } else {
      intervalKeys[`${idx}`] = {
        id: 0,
        keys: ['interval0'],
      }
    }
    this.setState({ intervalKeys });
  };


  handleSubmit = (e) => {
    const { match, form, onSubmit } = this.props;
    const { saleOrderData } = this.state;
    e.preventDefault();

    form.validateFields(async (err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData } = this.state;
      const data = Object.assign({}, values);
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      await saleOrderData.assets.map((item) => {
        data.assets[item.index].assetData = item.data;
      });

      if (match.params && match.params.id) {
        onSubmit(data, match.params.id);
      } else {
        onSubmit(data);
      }
    });
  };

  getAssetData(index, data) {
    const { saleOrderData } = this.state;
    saleOrderData.assets.push({ index: index, data: data[0] });
    this.setState({
      saleOrderData: saleOrderData,
    })
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  showAssets = (index, e) => {
    const { parentIntervalKeys } = this.state;
    const { assetsList } = this.props;
    const assets = [...this.state.assetsPresent];

    const selectedAsset = assetsList.find((asset) => asset._id === e);
    assets[index] = selectedAsset;

    if (selectedAsset && selectedAsset.parent && selectedAsset.parent !== null && selectedAsset.parent !== '') {
      parentPresent[index] = true;
      parentAssetCode[index] = (selectedAsset.parent && selectedAsset.parent.assetCode) || ''
      this.setState({
        assetsPresent: assets,
        parentPresent: parentPresent, parentAssetCode: parentAssetCode
      });
    }
    else {
      parentPresent[index] = false;
      delete parentIntervalKeys[index];
      parentAssetCode[index] = (selectedAsset.parent && selectedAsset.parent.assetCode) || ''
      this.setState({ assetsPresent: assets, parentIntervalKeys });
    }
  };

  componentWillUnmount() {
    parentPresent = [];
    parentAssetCode = [];
  }

  getAssetsByLocation = (e) => {
    this.props.fetchAssetsByLocation(e);
  };

  assetFormItems() {
    const { data, form, filters, assetsList, resource, title } = this.props;
    const { getFieldDecorator } = form;
    const { keys, assetsPresent } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys && isArray(keys) && keys.map((k, index) => {
      // const filteredAssetList = [];
      //
      // assetsList.forEach((asset) => {
      //   let present = false;
      //   assetsPresent.forEach((selectedAsset) => {
      //     if (asset._id === selectedAsset._id) {
      //       present = true;
      //     }
      //   });
      //
      //   if (!present && asset.status === 'ASSIGNED') {
      //     filteredAssetList.push(asset);
      //   }
      // });
      //
      // console.log(filteredAssetList);

      const { intervalKeys } = this.state;
      const { parentIntervalKeys } = this.state;

      const parentAssetFormItems = parentIntervalKeys && parentIntervalKeys[`${index}`] && parentIntervalKeys[`${index}`]['keys'] && parentIntervalKeys[`${index}`]['keys'].map((k, pIndex) => {
        const value = data.assets &&
          data.assets[index] &&
          data.assets[index].parentService &&
          data.assets[index].parentService[pIndex] &&
          data.assets[index].parentService[pIndex];

        return <div key={pIndex} style={style}>

          <Form.Item key={`${index}3`} label={'Meter'}>
            {getFieldDecorator(`assets[${index}]['parentService'][${pIndex}]['parentInterval']`, {
              rules: [{ required: true, message: `Parent Interval is required!` }],
              initialValue: (value && value.parentInterval) || '',
            })(<Input type='number' placeholder={'Meter'} disabled={true} style={{ marginRight: 8 }} />)
            }
          </Form.Item>

          <Form.Item key={`${index}2`} label={'Meter Unit'}>
            {getFieldDecorator(`assets[${index}]['parentService'][${pIndex}]['parentUnit']`, {
              rules: [{ required: true, message: `Meter Unit is required!` }],
              initialValue: (value && value.parentUnit) || '',
            })(<Select
              showSearch
              allowClear
              mode="single"
              disabled={true}
              style={{ width: '80%' }}
              placeholder={`Please Select Meter Unit`}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].data.data.map(item =>
                <Select.Option key={item._id} disabled={true}
                  value={item._id}>{item.name}</Select.Option>)}
            </Select>)
            }
            {/*{*/}
            {/*  filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].options.master ? <MasterModal resource={resource} item={filters['assets']['schema']['service']['schema']['unit'].options.ref} title={'CREATE'}/> : ''*/}
            {/*}*/}
          </Form.Item>

          {/*{pIndex >= 0 ? (*/}
          {/*  <Icon*/}
          {/*    className="dynamic-delete-button"*/}
          {/*    type="minus-circle-o"*/}
          {/*    disabled={true}*/}
          {/*    onClick={() => this.removeParentInterval(index, pIndex)}*/}
          {/*  />*/}
          {/*) : null}*/}
        </div>
      });

      const formItems = intervalKeys && intervalKeys[`${index}`] && intervalKeys[`${index}`]['keys'] && intervalKeys[`${index}`]['keys'].map((k, fIndex) => {
        const value = data.assets &&
          data.assets[index] &&
          data.assets[index].service &&
          data.assets[index].service[fIndex] &&
          data.assets[index].service[fIndex];

        return <div key={fIndex} style={style}>

          <Form.Item key={`${index}3`} label={'Meter'}>
            {getFieldDecorator(`assets[${index}]['service'][${fIndex}]['interval']`, {
              rules: [{ required: true, message: `Interval is required!` }],
              initialValue: (value && value.interval) || '',
            })(<Input type='number' disabled={true} placeholder={'Meter'} style={{ marginRight: 8 }} />)
            }
          </Form.Item>

          <Form.Item key={`${index}2`} label={'Meter Unit'}>
            {getFieldDecorator(`assets[${index}]['service'][${fIndex}]['unit']`, {
              rules: [{ required: true, message: `Meter Unit is required!` }],
              initialValue: (value && value.unit) || '',
            })(<Select
              showSearch
              allowClear
              disabled={true}
              mode="single"
              style={{ width: '80%' }}
              placeholder={`Please Select Meter Unit`}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].data.data.map(item =>
                <Select.Option key={item._id}
                  value={item._id}>{item.name}</Select.Option>)}
            </Select>)
            }
            {/*{*/}
            {/*  filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['service']['schema']['unit'].options.master ? <MasterModal resource={resource} item={filters['assets']['schema']['service']['schema']['unit'].options.ref} title={'CREATE'}/> : ''*/}
            {/*}*/}
          </Form.Item>

          {/*{fIndex >= 0 ? (*/}
          {/*  <Icon*/}
          {/*    className="dynamic-delete-button"*/}
          {/*    type="minus-circle-o"*/}
          {/*    onClick={() => this.removeInterval(index, fIndex)}*/}
          {/*  />*/}
          {/*) : null}*/}
        </div>
      });


      return <div key={index} style={style}>

        <Form.Item key={`${index}location`} label={'Location'}>
          {getFieldDecorator(`assets[${index}]['location']`, {
            rules: [{ required: false }],
            initialValue: data.assets && data.assets[index] && data.assets[index].asset && data.assets[index].location._id || '',
          })(<Select
            showSearch
            mode="single"
            onSelect={this.getAssetsByLocation.bind(this)}
            placeholder={`Please Select Location`}
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            disabled={true}
          >
            {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['location'].data.data.map(item =>
              <Select.Option key={item._id} disabled={true}
                value={item._id}>{item.name}</Select.Option>)}
          </Select>)}
        </Form.Item>


        <Form.Item key={`${index}0`} label={'Asset'}>
          {getFieldDecorator(`assets[${index}]['asset']`, {
            rules: [{ required: true, message: `Asset is required!` }],
            initialValue: data.assets && data.assets[index] && data.assets[index].asset && data.assets[index].asset._id || '',
          })(<Select
            showSearch
            mode="single"
            style={{ width: '100%' }}
            placeholder="Please select asset"
            onSelect={this.showAssets.bind(this, index)}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={true}
          >
            {assetsList && assetsList.length ? assetsList.map(item => {
              return <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>
            }) : data.assets && data.assets[index] ? <Select.Option
              value={data.assets[index] && data.assets[index].asset && data.assets[index].asset._id}>
              {data.assets && data.assets[index].asset && data.assets[index].asset.assetCode}</Select.Option> : ''}

          </Select>)}
        </Form.Item>

        <Form.Item key={`${index}3`} label={'Rate'}>
          {getFieldDecorator(`assets[${index}]['rate']`, {
            rules: [{ required: true, message: `Rate is required!` }],
            initialValue: data.assets && data.assets[index] && data.assets[index]['rate'],
          })(<Input type='number' placeholder={'Rate'} disabled={true} style={{ marginRight: 8 }} />)
          }
        </Form.Item>

        <Form.Item key={`${index}4`} label={'Parent Asset'}>
          {getFieldDecorator(`assets[${index}]['parentAsset']`, {
            rules: [{ required: true, message: `Parent Asset is required!` }],
            initialValue: data.assets && data.assets[index] && data.assets[index].parentAsset && data.assets[index].parentAsset._id || '',
          })(<Select
            showSearch
            mode="single"
            style={{ width: '100%' }}
            placeholder="Please select parent asset"
            // onSelect={this.showAssets.bind(this, index)}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={true}
          >
            {data.assets && data.assets[index] ? <Select.Option
              value={data.assets[index] && data.assets[index].parentAsset && data.assets[index].parentAsset._id}>
              {data.assets && data.assets[index].parentAsset && data.assets[index].parentAsset.assetCode}</Select.Option> : ''}

          </Select>)}
        </Form.Item>

        <Form.Item key={`${index}5`} label={'Remark'}>
          {getFieldDecorator(`assets[${index}]['remark']`, {
            rules: [{ required: true, message: `Remark is required!` }],
            initialValue: data.assets && data.assets[index] && data.assets[index]['remark'],
          })(<Input type='text' placeholder={'Remark'} disabled={true} style={{ marginRight: 8 }} />)
          }
        </Form.Item>


        {formItems}

        <Form.Item>
          <Button disabled={true} type="dashed" onClick={this.addInterval.bind(this, index)} style={{ width: '60%', marginTop: '15px' }}>
            <Icon type="plus" /> Add Asset Reading
          </Button>
        </Form.Item>

        {
          this.state.parentPresent[index] || (this.props && this.props.title && this.props.title === 'EDIT' &&
            data && data.assets
            && data.assets[index] && data.assets[index].parentAsset) ?
            <Form.Item label='Parent Asset'>
              {getFieldDecorator(`assets[${index}]['parentAsset']`, {
                initialValue: this.props && this.props.title && this.props.title === 'EDIT' ? data && data.assets
                  && data.assets[index] && data.assets[index].parentAsset : this.state.parentAssetCode[index] || ''
              })(<Select disabled={true} showArrow={false} />)}
            </Form.Item> : ''
        }
        {parentAssetFormItems}
        {
          this.state.parentPresent[index] ?
            <Form.Item>
              <Button disabled={true} type="dashed" onClick={this.addParentInterval.bind(this, index)} style={{ width: '60%', marginTop: '15px' }}>
                <Icon type="plus" /> Add Parent Asset Reading
              </Button>
            </Form.Item> : ''
        }

        {/*{index > 0 ? (*/}
        {/*  <Icon disabled={true}*/}
        {/*    className="dynamic-delete-button"*/}
        {/*    type="minus-circle-o"*/}
        {/*  />*/}
        {/*) : null}*/}
      </div>
    });
  }

  assetTable() {
    const { data, title, history } = this.props;
    const assetDataSource = [];
    const assetColumns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        key: 'rate',
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
      },
      {
        title: 'Edit',
        dataIndex: 'edit',
        key: 'edit',
        render: (id) => <Button type='info' disabled={true} onClick={() => history.push(`/asset/edit/${id}`)}>Edit</Button>
      }
    ];
    let assetTableData = title === 'EDIT' ? ((data && data.assets) || []) : [];
    assetTableData.map(item => {
      assetDataSource.push({
        key: item._id || Math.random(),
        assetCode: (item.asset && item.asset.assetCode) || '',
        status: (item.asset && item.asset.status) || '',
        rate: item.rate || 0,
        location: (item.location && item.location.name) || '',
        edit: item.asset && item.asset._id
      })
    });
    return <Table columns={assetColumns} dataSource={assetDataSource} pagination={false} />
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, history, match } = this.props;
    const conditionForView = {
      viewOption: true,
      resourceName: "salesInvoice"
    };


    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName('salesInvoice')}`}>
          <Form onSubmit={this.handleSubmit} disabled={true} layout="vertical">

            {/*{Object.keys(filters).map((item) => {*/}
            {/*  if (filters[item].type === 'Array' && filters[item].schema) {*/}
            {/*    return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>*/}
            {/*  } else {*/}
            {/*    return getFormFieldByType(filters, item, getFieldDecorator, data)*/}
            {/*  }*/}
            {/*})}*/}

            <Form.Item key={'saleDate'} label={'Sale Date'}>
              {getFieldDecorator('saleDate', {
                rules: [{ required: true, message: `Sale Date is required!` }],
                initialValue: data && data.saleDate && moment(data.saleDate),
              })(<DatePicker disabled={true} />)
              }
            </Form.Item>

            <Form.Item key={'vendor'} label={'Vendor'}>
              {getFieldDecorator('vendor', {
                rules: [{ required: true, message: `Vendor is required!` }],
                initialValue: data && data.vendor && data.vendor._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={true}
              >
                {filters['vendor'] && filters['vendor']['data'] && filters['vendor']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {/*{*/}
              {/*  filters['vendor'] && filters['vendor'].options && filters['vendor'].options.master ? <MasterModal resource={resource}  item={filters['vendor'].options.ref} title={'CREATE'}/> : ''*/}
              {/*}*/}
            </Form.Item>
            <br />
            <div>Assets</div>
            {this.assetFormItems()}
            <Button disabled={true} type="dashed" style={{ width: '60%', marginTop: '15px' }}>
              <Icon type="plus" /> Add Asset
            </Button>
            <DocumentList history={history} viewOption={conditionForView} match={match} key={'documents'} item={filters['documents']} form={form}
              data={data['documents']} getDocumentData={this.getDocumentData} />


          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(View);

export default CreateForm;
